import {
  FilledInput as MuiFilledInput,
  type FilledInputProps as MuiFilledInputProps,
  FormGroup as MuiFormGroup,
  type FormGroupProps as MuiFormGroupProps,
  Input as MuiInput,
  InputAdornment as MuiInputAdornment,
  type InputAdornmentProps as MuiInputAdornmentProps,
  InputBase as MuiInputBase,
  type InputBaseProps as MuiInputBaseProps,
  type InputProps as MuiInputProps,
  OutlinedInput as MuiOutlinedInput,
  type OutlinedInputProps as MuiOutlinedInputProps,
} from "@mui/material";

export type InputProps = MuiInputProps;
export type InputBaseProps = MuiInputBaseProps;
export type InputAdornmentProps = MuiInputAdornmentProps;
export type OutlinedInputProps = MuiOutlinedInputProps;
export type FilledInputProps = MuiFilledInputProps;
export type FormGroupProps = MuiFormGroupProps;

export const Input = MuiInput;
export const InputBase = MuiInputBase;
export const InputAdornment = MuiInputAdornment;
export const OutlinedInput = MuiOutlinedInput;
export const FilledInput = MuiFilledInput;
export const FormGroup = MuiFormGroup;
